import { apiClient } from './api'

export interface ReportConfig {
  entity_type: string
  entity_id: number
  report_type: string
  include_sections: string[]
}

export interface ScheduledReport {
  id: number
  name: string
  report_config: ReportConfig
  frequency: 'daily' | 'weekly' | 'monthly' | 'on_trigger'
  trigger_event?: string
  recipient_emails: string[]
  format: 'pdf' | 'excel' | 'json'
  last_sent_at?: string
  next_send_at: string
  is_active: boolean
  created_at: string
}

export interface CreateScheduledReport {
  name: string
  report_config: ReportConfig
  frequency: ScheduledReport['frequency']
  trigger_event?: string
  recipient_emails: string[]
  format: ScheduledReport['format']
  next_send_at: string
}

export const scheduledReportsService = {
  list: async (): Promise<ScheduledReport[]> => {
    const { data } = await apiClient.get('/api/v1/scheduled-reports')
    return data
  },

  create: async (payload: CreateScheduledReport): Promise<ScheduledReport> => {
    const { data } = await apiClient.post('/api/v1/scheduled-reports', payload)
    return data
  },

  update: async (id: number, payload: Partial<CreateScheduledReport & { is_active: boolean }>): Promise<ScheduledReport> => {
    const { data } = await apiClient.put(`/api/v1/scheduled-reports/${id}`, payload)
    return data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/scheduled-reports/${id}`)
  },

  trigger: async (id: number): Promise<{ ok: boolean; message: string; recipients: string[]; format: string }> => {
    const { data } = await apiClient.post(`/api/v1/scheduled-reports/${id}/trigger`)
    return data
  },
}
